import {decorate, observable} from "mobx";
import Api from "../util/api";
import {messageErreur} from "./smsStore";

/** Le bandeau d'un appel terminé reste affiché quelques secondes. */
const DELAI_FERMETURE_MS = 15000;

/**
 * Téléphonie OVH : click2call depuis un numéro, bandeau « appel entrant » et journal des appels.
 */
export default class TelephonieStore {

    // click2call disponible sur ce serveur (sinon les numéros gardent leur lien tel:)
    click2call = false;
    manquesATraiter = 0;

    // Bandeau : l'appel en cours de sonnerie ou de conversation, null s'il n'y en a pas
    appelEntrant = null;

    // Journal
    appels = observable([]);
    currentPage = 1;
    lastPage = 1;
    limit = 30;
    statut = "manque";
    aTraiter = true;
    statuts = {};

    constructor(rootStore) {
        this.rootStore = rootStore;
        this.api = new Api();
    }

    async getEtat() {
        try {
            const etat = await this.api.telephonie.getEtat();
            this.click2call = !!etat.click2call;
            this.manquesATraiter = etat.manques_a_traiter ?? 0;
        } catch (e) {
            this.click2call = false;
        }
    }

    /** Fait sonner le téléphone du magasin, qui appellera ce numéro au décroché. */
    async appeler(numero) {
        try {
            const reponse = await this.api.telephonie.appeler(numero);
            this.rootStore.notificationStore.setNotification(reponse.message, "success", 8000);
            return true;
        } catch (e) {
            this.rootStore.notificationStore.setNotification(messageErreur(e), "error");
            return false;
        }
    }

    /** Événement temps réel « AppelEvent » : ouvre, met à jour ou referme le bandeau. */
    recevoir(appel) {
        if (!appel) {
            return;
        }
        clearTimeout(this.minuteur);

        if (appel.statut === "sonne" || appel.statut === "en_cours") {
            this.appelEntrant = appel;
            return;
        }

        if (this.appelEntrant && this.appelEntrant.id !== appel.id) {
            return; // fin d'un autre appel : le bandeau affiché reste
        }
        this.appelEntrant = appel;
        if (appel.statut === "manque") {
            this.manquesATraiter += 1;
        }
        this.minuteur = setTimeout(() => this.fermerBandeau(), DELAI_FERMETURE_MS);
    }

    fermerBandeau() {
        clearTimeout(this.minuteur);
        this.appelEntrant = null;
    }

    async getAppels() {
        this.rootStore.savedDatasStore.setLoading(true);
        try {
            const reponse = await this.api.telephonie.getAppels(this.currentPage, this.limit, this.statut, this.aTraiter);
            this.appels.replace(reponse.data);
            this.currentPage = reponse.current_page;
            this.lastPage = reponse.last_page;
            this.statuts = reponse.statuts ?? {};
            this.manquesATraiter = reponse.manques_a_traiter ?? 0;
        } catch (e) {
            this.rootStore.notificationStore.setNotification(messageErreur(e), "error");
        }
        this.rootStore.savedDatasStore.setLoading(false);
    }

    async traiter(id) {
        try {
            await this.api.telephonie.traiter(id);
            await this.getAppels();
            return true;
        } catch (e) {
            this.rootStore.notificationStore.setNotification(messageErreur(e), "error");
            return false;
        }
    }
}

decorate(TelephonieStore, {
    click2call: observable,
    manquesATraiter: observable,
    appelEntrant: observable,
    currentPage: observable,
    lastPage: observable,
    statut: observable,
    aTraiter: observable,
    statuts: observable,
});
